import './utils/validateFileSize'
import { initializeSortables } from './utils/sortable'

htmx.onLoad(function (content: HTMLElement) {
  initializeSortables(content)
})
